import { SET_APP_HOST, GET_CONFIDENTIALITY_LEVELS, GET_QUOTAS, GET_LOCATIONS, SET_NAVIGATION_KEY } from "../actions/types";

const initialState = {
    navigation: null,
    hostApp: null,
    isMsTeamsApp: false,
    siteConfidentialityLevels: [],
    siteQuotas: [],
    siteLocations: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_NAVIGATION_KEY:
            return {
                ...state,
                navigation: action.payload
            };
        case SET_APP_HOST:
            return {
                ...state,
                hostApp: action.payload,
                isMsTeamsApp: action.payload === 'teams'
            };
        case GET_CONFIDENTIALITY_LEVELS:
            return {
                ...state,
                siteConfidentialityLevels: action.payload
            }
        case GET_QUOTAS:
            return {
                ...state,
                siteQuotas: action.payload
            }
        case GET_LOCATIONS:
            return {
                ...state,
                siteLocations: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js